import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import flechaAvanzar from "../assets/right-arrow.svg";
import ScenarioBar from "../components/ScenarioBar";
import { useLang } from "../translations/i18n";
import { ROUTES } from "../utils/constants";
import { updateStats, updateTimer } from "../utils/helpers";
import { modalWait } from "../utils/logger";
import oncommit from "../assets/oncommit.png";
import avatarVideo from "../assets/bg/silent-video.webm";
import avatarVideoMp4 from "../assets/bg/silent-video.mp4";

import { useVideoWithSound } from "../hooks/useVideoWithSound";

function GameIntroduction({ intl }) {
  const lang = useLang();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const game = useSelector((state) => state.game);
  const group = useSelector((state) => state.group);
  const [isCompleted, setIsCompleted] = useState(false);
  const [loading, setLoading] = useState(false);
  const { state } = useLocation();
  const { completed } = state || false;

  const { videoRef, canPlayWithSound } = useVideoWithSound({ 
	autoPlay: true, 
	volume: 0.8
  });

  const activeScenario = 0;

  const handleStartGame = (e, direction = "next") => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);

    getGameById(game?._id).then((res) => {
      if (res.status === 200) {
        updateStats({
          ...group,
          actualScenario: 1,
          time: 0,
          lastVisited: ROUTES.START_GAME5,
        });

        navigate(ROUTES.START_GAME5, {
          state: { activeScenario: 1 },
        });
      } else {
      	setLoading(false);
	  }
    });
  };
  return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-between h-100 px-4 pb-5">
						<img
							className="mt-4"
							src={oncommit}
							alt="decorativo"
							style={{
								maxWidth: "60%",
							}}
						/>
						<h1 className="txtTitulos bold">
						Reglas del Patient Room III
						</h1>
						<video
							ref={videoRef}
							autoPlay
							playsInline
							preload="auto"
							muted
							loop
						>
							<source src={avatarVideoMp4}  type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
					</div>

					{/* Columna derecha: espacio visual */}
					<div className="col-md-8 d-flex flex-column justify-content-center align-items-end h-100 px-4 bgCircleRed">
						<div className="recuadro mb-2 w-100">
							<h3 className="txtTexto1 bold">
								Retroalimentación
							</h3>
							<p className="txtTexto1">
								Conseguirás retroalimentación en los momentos clave del caso.
							</p>
						</div>
						<div className="recuadro mb-2 w-100">
							<h3 className="txtTexto1 bold">
								El equipo con mayor puntuación total será el ganador.
							</h3>
							<p className="txtTexto1">
								En caso de empate, ganará el equipo que haya resuelto el caso en menos tiempo hasta la última pantalla.
							</p>
						</div>
						<div className="recuadro mb-2 w-100">
							<h3 className="txtTexto1 bold">
								Atención
							</h3>
							<p className="txtTexto1">
								No está permitido manipular material que no esté identificado como parte del juego.
							</p>
						</div>
						<div className="recuadro mb-2 w-100">
							<h3 className="txtTexto1 bold txtRed">
								Recuerda
							</h3>
							<p className="txtTexto1 txtRed">
								Lo importante no es solo ganar, sino aprender y aplicar la evidencia científica en la práctica clínica.
							</p>
						</div>
						<div className="d-flex justify-content-end align-items-center">
							<div className="txtBotones me-3">
								Siguiente
							</div>
							<button
								onClick={(e) => handleStartGame(e, "next")}
								className="btn-main btn-progress"
								data-loading={loading ? "true" : "false"}
								style={{ width: 80, height: 80, borderRadius: "50%" }}
								aria-busy={loading}
							>
								<img
								src={flechaAvanzar}
								alt="Siguiente"
								style={{ maxWidth: "40px" }}
								/>
							</button>              
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(GameIntroduction);
